<template>
  <div>
    <section id="container" class="gnb_pdt">
      <div class="title_wrap">
        <h1 class="f_l">일렉트론 앱 버전 관리</h1>
      </div>
      <!--  검색 창  -->
      <div class="contents_wrap mg0">
        <div class="content_list">
          <div class="button_wrap_area">
            <ul>
              <li>
                <button class="large_btn orange" @click="commonOnChangeEvent">검색</button>
              </li>
              <li>
                <button class="large_btn" @click="cleanFilter">초기화</button>
              </li>
            </ul>
          </div>
          <!--          검색 필터-->
          <div id="filter_section" class="filter_wrap">
            <ul class="filter_list">
              <li class="col2">
                <dd>
                  <label>버전 검색</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          ref="versionNmRef"
                          :value="lastRouteParams.versionNm"
                          :placeholder="'버전 명 입력'"
                          class='w100'
                          id="versionNm"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>타입</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="kioskTypeRef"
                          :index="0"
                          :value="lastRouteParams.kioskType"
                          :style="{width: '100%', border: '0'}"
                          @select="commonOnChangeEvent"
                      >
                        <kendo-buttongroup-button
                            v-for="item in ['전체', '[A]사내물류', '[B]의료비|학자금', '[C]리셉션|출입증']"
                            v-bind:key="item"
                        >
                          {{ item }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
              </li>
              <li class="col2">
                <dd>
                  <label>등록자 검색</label>
                  <ul>
                    <li>
                      <kendo-maskedtextbox
                          ref="rgstIdRef"
                          :value="lastRouteParams.rgstId"
                          :placeholder="'등록자 입력'"
                          class='w100'
                          id="rgstId"
                          @change="commonOnChangeEvent"
                      >
                      </kendo-maskedtextbox>
                    </li>
                  </ul>
                </dd>
                <dd>
                  <label>사용 가능 여부</label>
                  <ul>
                    <li>
                      <kendo-buttongroup
                          ref="useYnRef"
                          :index="0"
                          :value="lastRouteParams.useYn"
                          :style="{width: '100%', border: '0'}"
                          @select="commonOnChangeEvent"
                      >
                        <kendo-buttongroup-button
                            v-for="item in ['전체', '사용', '미사용']"
                            v-bind:key="item"
                        >
                          {{ item }}
                        </kendo-buttongroup-button>
                      </kendo-buttongroup>
                    </li>
                  </ul>
                </dd>
              </li>
            </ul>
          </div>
          <!--          검색필터 끝-->
        </div>
      </div>
      <!--  버튼 영역  -->
      <div class="dblock mgt20">
        <div class="c_t_button_wrap f_l">
          <button class="mid_btn orange mr5" @click="onClickVersionSave"><span><span class="k-icon k-i-plus"></span>버전 등록</span></button>
          <button class="mid_btn mr5" @click="onClickUpdateUseYn('활성화')"><span>버전 활성화</span></button>
          <button class="mid_btn" @click="onClickUpdateUseYn('비활성화')"><span>버전 비활성화</span></button>
        </div>
      </div>
      <!--  리스트 영역 -->
      <kendo-grid
          ref="versionListGridRef"
          id="grid"
          style="cursor: pointer;"
          class="basic_table mt10"
          :data-source="versionListDataSource"
          :columns="versionListColumns"
          :navigatable="true"
          :filterable="false"
          :sortable="true"
          :scrollable="true"
          :pageable-always-visible="true"
          :pageable-page-sizes="[5, 10, 20, 50, 100, 500, 1000]"
          :reorderable="true"
          :column-menu="false"
          :resizable="true"
          :selectable="'multiple row'"
          @change="onChangeGrid"
          :noRecords="{ template: '<div class=\'gridNoData\' style=\'text-align: center;\'>표시할 데이터가 없습니다.</div>' }">
      </kendo-grid>
    </section>
  </div>
</template>
<script>
import ApiConfig from "@/api/api.config";
import {LogisticsCodeDtlMixin, ZoneMixin} from "@/mixin/Mixin";
import EtnersParseUtil from "@/common/etners.parse.util";
import $ from "jquery"
import Apiconfig from '@/api/api.config'
import ApiUtil from '@/api/api.util'

export default {
  name: "VersionList",
  mixins: [LogisticsCodeDtlMixin],
  mounted() {
    const vm = this
    // 페이지 로딩 시 호출
    this.getversionList()
    //엔터키 이벤트 자동 세팅
    const enterkeyEventTargetIdArray = [
      'versionNm', 'rgstId'
    ]
    for (const elementId of enterkeyEventTargetIdArray) {
      const element = document.getElementById(elementId)
      if (element !== undefined) {
        element.onkeyup = function (e) {
          const ENTER_KEY_CODE = 'Enter'
          const NUM_PAD_ENTER = 'NumpadEnter'
          const currentKeyCode = e.code

          if (currentKeyCode === ENTER_KEY_CODE || currentKeyCode === NUM_PAD_ENTER) {
            vm.commonOnChangeEvent(e)
          }
        }
      }
    }
  },
  methods: {
    // 리스트 api 호출
    getversionList() {
      const vm = this
      const lastRequestParameterPage = vm.lastRouteParams.page !== undefined ? vm.lastRouteParams.page : 1
      const lastRequestParameterPageSize = vm.lastRouteParams.pageSize !== undefined ? vm.lastRouteParams.pageSize : 10

      vm.versionListDataSource = new kendo.data.DataSource({
        name: 'versionListDataSource',
        page: lastRequestParameterPage,
        pageSize: lastRequestParameterPageSize,
        serverPaging: true,
        serverFiltering: true,
        serverSorting: true,
        transport: {
          read: {
            url: `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/electron/versionList.json`,
            type: 'POST',
            dataType: 'json',
            contentType: 'application/json',
            cache: false
          },
          parameterMap(options, operation) {
            if (operation === 'read') {
              const paramToKendoFilters = vm.currentPageFilterOption()
              const params = {
                loginUserToken: vm.loginUserToken,
                skip: options.skip,
                take: options.take,
                sort: options.sort,
                page: options.page,
                pageSize: options.pageSize,
                versionNm: paramToKendoFilters.versionNm,
                kioskType: paramToKendoFilters.kioskType,
                frstRgstId: paramToKendoFilters.rgstId,
                useYn: paramToKendoFilters.useYn,
                requestType: 'PAGING'
              }
              sessionStorage.setItem('LAST_ROUTE_PARAMS', kendo.stringify(params))
              return kendo.stringify(params)
            }
            if (operation !== 'read' && options.models) {
              return {models: kendo.stringify(options.models)}
            }
          }
        },
        schema: {
          type: 'json',
          parse(response) {
            if (response.resultStatus.messageCode !== '2000') {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
            const changeResultData = response.resultData
            let rowNumber = response.total > 1 ? response.total - ((vm.$refs.versionListGridRef.dataSource.page() - 1) * vm.$refs.versionListGridRef.dataSource.pageSize()) : response.total

            if (changeResultData === null) {
              return false
            }
            for (let i = 0; i < changeResultData.length; i++) {
              const row = changeResultData[i]
              row.rowNumber = rowNumber--
            }
            response.resultData = changeResultData
            return response
          },
          total(response) {
            return response.total
          },
          data(response) {
            if (response.resultStatus.messageCode === '2000') {
              vm.versionList = response.resultData
              return response.resultData
            } else {
              kendo.alert('message: ' + response.resultStatus.messageText)
              return ''
            }
          }
        },
        error(e) {
          // console.log('error event handler', e.errors)
        }
      })
    },
    // 검색 조건
    currentPageFilterOption() {
      const vm = this
      const refs = vm.$refs

      const currentSearchDataObj = {}

      if (refs.versionNmRef !== undefined) {
        const versionNm = refs.versionNmRef.kendoWidget().value()
        if (versionNm !== null && versionNm !== '') {
          currentSearchDataObj.versionNm = versionNm
        }
      }

      if (refs.kioskTypeRef !== undefined) {
        const kioskType = refs.kioskTypeRef.kendoWidget().current().index()
        if (kioskType !== '' && kioskType !== null) {
          let resultkioskType
          if (kioskType === 0) {
            resultkioskType = ''
          } else if (kioskType === 1) {
            resultkioskType = '01'
          } else if (kioskType === 2) {
            resultkioskType = '02'
          }else if (kioskType === 3) {
            resultkioskType = '03'
          }
          currentSearchDataObj.kioskType = resultkioskType
        }
      }

      if (refs.rgstIdRef !== undefined) {
        const rgstId = refs.rgstIdRef.kendoWidget().value().trim()
        if (rgstId !== null && rgstId !== '') {
          currentSearchDataObj.rgstId = rgstId
        }
      }

      if (refs.useYnRef !== undefined) {
        const useYn = refs.useYnRef.kendoWidget().current().index()
        if (useYn !== '' && useYn !== null) {
          let resultUseYn
          if (useYn === 0) {
            resultUseYn = ''
          } else if (useYn === 1) {
            resultUseYn = 'Y'
          } else if (useYn === 2) {
            resultUseYn = 'N'
          }
          currentSearchDataObj.useYn = resultUseYn
        }
      }
      return currentSearchDataObj
    },
    // 검색 버튼 호출
    commonOnChangeEvent() {
      const vm = this
      const gridRefs = this.$refs.versionListGridRef

      if (gridRefs !== undefined && gridRefs.kendoWidget() !== undefined) {
        if (vm.lastRouteParams.page === undefined) {
          gridRefs.kendoWidget().dataSource.page(1)
        } else {
          gridRefs.kendoWidget().dataSource.read()
          this.lastRouteParams.page = undefined
        }
      }
    },
    // 초기화 버튼
    cleanFilter() {
      const vm = this
      const refs = vm.$refs

      if (refs.versionNmRef !== undefined) {
        refs.versionNmRef.kendoWidget().value('')
      }
      if (refs.kioskTypeRef !== undefined) {
        refs.kioskTypeRef.kendoWidget().select(0)
      }
      if (refs.rgstIdRef !== undefined) {
        refs.rgstIdRef.kendoWidget().value('')
      }
      if (refs.useYnRef !== undefined) {
        refs.useYnRef.kendoWidget().select(0)
      }
      vm.getversionList()
    },
    // 버전 등록으로 이동
    onClickVersionSave() {
      const vm = this
      vm.$router.push({
        name: 'VersionSave'
      })
    },
    // 버전 활성화, 비활성화 버튼
    onClickUpdateUseYn (status) {
      const vm = this
      const selectedRows = vm.$refs.versionListGridRef.kendoWidget().select()
      if(selectedRows.length === 0){
        kendo.alert('버전을 선택해주세요.')
        return
      }
      // 일괄 완료 처리 대상
      let versionIdList = []
      for (let selectedRowValue of selectedRows) {
        const row = vm.$refs.versionListGridRef.kendoWidget().dataItem(selectedRowValue)
        // 일괄 비활성화, 활성화시 다른 값을 가진 데이터 점검
        if (row.useYn === status) {
          kendo.alert('이미 '+ status +'된 버전을 선택하셨습니다.')
          return
        }
        versionIdList.push(row.versionId)
      }
      kendo.confirm(`총 ${versionIdList.length} 건의 데이터를 일괄 ${status} 처리하시겠습니까?`).done(function () {
        // 일괄 완료 처리 api 호출
        const url = `${ApiConfig.eklDomain}/v1/ebmp/ai/manager/portal/electron/versionStatusSave.json`
        const param = {
          loginUserToken: vm.loginUserToken,
          versionIdList: versionIdList,
          useYn: (status === '활성화' ? 'Y' : 'N')
        }
        ApiUtil.post(url, param).then(response => {
          if (response.data === undefined || response.data.resultStatus === undefined) {
            kendo.alert('데이터를 정상적으로 받아오지 못했습니다.')
            return false
            const resultStatus = response.data.resultStatus
            if (resultStatus.messageCode !== '2000') {
              return false
            }
          }
          kendo.alert(`${response.data.resultData.count} 건이 일괄 ${status} 처리 되었습니다.`)
          vm.getversionList()
        })
      })
    },
    // 버전 상세로 이동
    onChangeGrid(e) {
      const selectedRow = e.sender.select()
      const selectedIndex = e.sender._lastCellIndex
      const item = e.sender.dataItem(selectedRow)

      if(!([0].includes(selectedIndex))){
        this.$router.push({
          name: 'VersionDetail',
          params: {
            versionId: item.versionId
          },
        })
      }
    },
  },
  data: function () {
    const kendoGridHeaderAttributes = {
      style: 'font-weight: bold; text-align : center;'
    }
    const vm = this
    return {
      loginUserToken: sessionStorage.getItem('loginUserToken'),
      versionListDataSource: [],
      dataSourceArray: [],
      lastRouteParams: [],
      versionList: [],
      versionListColumns: [
        {
          title: '전체선택',
          selectable: true,
          width: "8%",
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'rowNumber',
          title: 'No.',
          sortable: false,
          width: '10%',
        },
        {
          field: 'versionNm',
          title: '버전',
          width: '20%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'kioskTypeNm',
          title: '타입',
          width: '15%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'summary',
          title: '설명',
          width: '80%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          }
        },
        {
          field: 'useYn',
          title: '활성화',
          width: '15%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
          template(dataItem){
            if (dataItem.useYn === 'Y'){
              return dataItem.useYn = "활성화"
            }
            if (dataItem.useYn === 'N'){
              return dataItem.useYn = "비활성화"
            }
          },
        },
        {
          field: 'frstRgstId',
          title: '등록자',
          width: '15%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        },
        {
          field: 'lastMdfyDt',
          title: '수정 일시',
          width: '15%',
          headerAttributes: kendoGridHeaderAttributes,
          attributes: {
            class: 'tcenter'
          },
        }
    ]
    }
  }
}
</script>
